import { Module } from '../Module';
import { ScheduleActions } from '../ServerApi/types/ISchedule';

export interface IScheduleActionNameFilter {
  (scheduleAction: string): string;
}

Module.instance().filter('scheduleActionName', [
  '$translate',
  ($translate: ng.translate.ITranslateService): IScheduleActionNameFilter => {
    return (scheduleAction: string) => {
      switch(scheduleAction) {
        case ScheduleActions.Extract:
          return $translate.instant('extractRefresh');
        case ScheduleActions.Subscription:
          return $translate.instant('subscription');
        case ScheduleActions.Flow:
          return $translate.instant('flow');
      }
      return '';
    };
  }
]);
